
import axios from "axios";
import React, { Component } from 'react';
import { Button, IconButton } from '@mui/material';
import { Box } from "@mui/material";
import Cookies from "js-cookie";
import settings from "../helpers/Settings";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import PaidIcon from '@mui/icons-material/Paid';
import FormControl from "@mui/material/FormControl";
import Modal from "@mui/material/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from '@mui/material/MenuItem';
import Typography from "@mui/material/Typography";
import VisibilityIcon from '@mui/icons-material/Visibility';


let { KayanURL } = settings;
const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    bgcolor: "background.paper",
    border: "2px solid gray",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
};
class PaymentReconsiliation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            paymentLoading: false,
            pollLoading: false
        };
    }

    componentDidMount = async () => {
        this.getAllpayments();
    };
    getAllpayments = async () => {
        this.setState({ paymentLoading: true })
        let response = await axios.put(
            KayanURL + "api/KSA/RCM/patient/getAllPaymentsInfo",
            { apiToken: Cookies.get("RCM_KSA_Employee_Token") }
        );
        if (response) {
            let { data } = response;
            if (data) {
                this.setState({ paymentLoading: false })
                let noticeErrorExist = false
                if (data.success) {
                    let noticeErrorExist = false;

                    for (let i = 0; i < data.payments.length; i++) {
                        if (data.payments[i].noticeerror) {
                            noticeErrorExist = true;
                            break;
                        }
                    }
                    this.setState({
                        success: true,
                        allPayments: data.payments,
                        noticeErrorExist
                    });
                } else {
                    this.setState({
                        success: false,
                        error: data.error,
                        allPayments: data.payments,
                    });
                }
            }
        }
    };
    handleSubmitPaymentNotice = async (e) => {
        e.preventDefault()
        this.setState({ noticeLoading: true })
        let response
            = await axios.post(
                "http://141.147.130.248:4000/api/KSA/RCM/request",
                // KayanURL + "api/KSA/RCM/request",
                {
                    requestType: "7",
                    apiToken: "token",
                    providerID: "10000300178702",
                    providerName: "Al-Faraby Medical Center (Dhahran)",
                    paymentReconciliationIdentifier: this.state.paymentReconciliationIdentifier,
                    paymentDate: this.state.paymentDate,
                    paymentAmount: this.state.paymentAmount.split(' ')[0],
                    paymentStatus: this.state.paymentStatus,
                    testing: true
                }
            );
        if (response) {
            setTimeout(() => {
                this.setState({ noticeLoading: false });
            }, 500);
            let { data } = response;


            if (data) {
                let { success, error, BundleID, acknowledgmentStatus } = data;
                if (success) {
                    this.setState({ successNotice: success })
                    if (acknowledgmentStatus === "fatal-error" && error && error.length) {
                        this.setState({ noticeErrors: error })
                        this.updatePaymentInfo(acknowledgmentStatus, error)
                    } else {
                        this.setState({ acknowledgmentStatus, BundleID })
                        this.updatePaymentInfo(acknowledgmentStatus, "")
                    }
                } else {
                    this.setState({ error });
                    console.log(error);
                }
            }
        }
    }
    handlePollRec = async (e) => {
        e.preventDefault();
        this.setState({ pollLoading: true });
        // let response
        //     = await axios.post(
        //         "http://141.147.130.248:4000/api/KSA/RCM/request",
        //         // KayanURL + "api/KSA/RCM/request",
        //         {
        //             requestType: "5",
        //             apiToken: "token",
        //             providerID: "10000300178702",
        //             providerName: "Al-Faraby Medical Center (Dhahran)",
        //             include: "payment-reconciliation",
        //             returnFullResponse: true,
        //             testing: true

        //         }
        //     );
        let response = {
            data: {
                "success": true,
                "paymentReconciliation": [
                    {
                        "id": 1,
                        "paymentReconciliationIdentifier": "http://sni.com.sa/paymentreconciliation/922283",
                        "paymentDate": "2021-11-02",
                        "paymentAmount": "1186.2 SAR",
                        "payementPeriod": {
                            "start": "2021-10-01",
                            "end": "2021-10-31"
                        },
                        "outcome": "complete",
                        "disposition": "Payment made for the month of October, 2021",
                        "details": [
                            {
                                "identifier": "",
                                "paymentType": "payment",
                                "claimRequestIdentifier": "http://saudidentalclinic.com.sa/claim/req_296211",
                                "claimResponseIdentifier": "http://sni.com.sa/claimresponse/resp_616211",
                                "commitmentDate": "2021-10-10",
                                "amount": "1186.2 SAR",
                                "benefit": "1200 SAR",
                                "earlyPaymentFee": "0 SAR",
                                "nphiesFee": "-13.8 SAR"
                            }
                        ]
                    },
                    {
                        "id": 2,
                        "paymentReconciliationIdentifier": "http://sni.com.sa/paymentreconciliation/922284",
                        "paymentDate": "2021-11-02",
                        "paymentAmount": "1186.2 SAR",
                        "payementPeriod": {
                            "start": "2021-10-01",
                            "end": "2021-10-31"
                        },
                        "outcome": "complete",
                        "disposition": "Payment made for the month of October, 2021",
                        "issuerName": "Saudi National Insurance",
                        "issuerID": "N-I-00001",
                        "details": [
                            {
                                "identifier": "",
                                "paymentType": "payment",
                                "claimRequestIdentifier": "http://saudidentalclinic.com.sa/claim/req_296211",
                                "claimResponseIdentifier": "http://sni.com.sa/claimresponse/resp_616211",
                                "commitmentDate": "2021-10-10",
                                "amount": "1186.2 SAR",
                                "benefit": "1200 SAR",
                                "earlyPaymentFee": "0 SAR",
                                "nphiesFee": "-13.8 SAR"
                            }
                        ]
                    }
                ]
            }
        }
        if (response) {
            setTimeout(() => {
                this.setState({ pollLoading: false });
            }, 500);
            let { data } = response;


            if (data) {
                let { success, paymentReconciliation, error } = data;
                if (success) {
                    if (paymentReconciliation && paymentReconciliation.length > 0)
                        this.handleAddPollResponse(paymentReconciliation);
                } else {
                    this.setState({ error });
                    console.log(error);
                }
            }
        }
    };
    handleAddPollResponse = async (paymentReconciliation) => {
        let Response = await axios.post(
            KayanURL + "api/KSA/RCM/patient/addPaymentInfo",
            {
                paymentReconciliation,
                apiToken: Cookies.get("RCM_KSA_Employee_Token"),
            }
        );
        if (Response) {
            let { data } = Response;
            console.log(data);
            if (data) {
                if (data.success) {
                    let { payments } = data;
                    if (payments && payments.length > 0) {
                        this.setState({ allPayments: payments })
                    }
                    this.getAllpayments()
                } else {
                    console.log(
                        "error in update or add the authorization response of a visit:",
                        data.error
                    );
                    this.setState({ success: false /* , error: data.error */ });
                }
            }
        }
    };
    updatePaymentInfo = async (status, error) => {
        let response = await axios.put(
            KayanURL + "api/KSA/RCM/patient/updatePaymentStatus",
            {
                apiToken: Cookies.get("RCM_KSA_Employee_Token"),
                ID: this.state.paymentID,
                status: status,
                noticeError: error
            }
        );
        if (response) {
            let { data } = response;
            if (data) {
                if (data.success) {
                    this.setState({
                        success: true,
                    });
                    this.getAllpayments()
                } else {
                    this.setState({
                        success: false,
                        error: data.error,
                    });
                }
            }
        }
    };
    handleCloseNoticeModal = () => {
        this.setState({ noticeModal: false, paymentStatus: "", acknowledgmentStatus: "", noticeErrors: "", successNotice: false });
    };
    handleCloseErrorModal = () => {
        this.setState({ errorModal: false });
    };
    HandleInputTextChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    render() {
        let { allPayments, noticeErrors } = this.state;
        let paymentRows = [];
        if (allPayments && allPayments.length > 0) {
            paymentRows = allPayments.map((ele, index) => {
                let { details } = ele;
                let detailRows = []
                if (details && details.length > 0) {
                    detailRows = details.map((ele, index) => {
                        return (
                            <TableRow key={index}>
                                <TableCell align="center" style={{ fontSize: "small" }}>
                                    {ele.identifier}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: "small" }}>
                                    {ele.claimRequestIdentifier}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: "small" }}>
                                    {ele.claimResponseIdentifier}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: "small" }}>
                                    {ele.paymentType}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: "small" }}>
                                    {ele.commitmentDate}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: "small" }}>
                                    {ele.nphiesFee}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: "small" }}>
                                    {ele.earlyPaymentFee}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: "small" }}>
                                    {ele.benefit}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: "small" }}>
                                    {ele.amount}
                                </TableCell>
                            </TableRow>
                        )
                    })
                }
                return (
                    <TableRow key={index}>
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            {ele.id}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            {ele.paymentreconciliationidentifier}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            {ele.disposition}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            {ele.paymentdate}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            From {ele.payementperiod.start} To {ele.payementperiod.end}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            {ele.paymentamount}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            {ele.issuername && ele.issuername !== "null" ? ele.issuername : ""}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            {ele.issuerid && ele.issuerid !== "null" ? ele.issuerid : ""}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                            <TableContainer
                                component={Paper}
                                style={{ padding: "0" }}
                            >
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead style={{ backgroundColor: "#fafafa" }}>
                                        <TableRow style={{ textAlign: "center" }}>
                                            <TableCell align="center">Identifier</TableCell>
                                            <TableCell align="center">Claim Request Identifier</TableCell>
                                            <TableCell align="center">claim Response Identifier</TableCell>
                                            <TableCell align="center">Payment Type</TableCell>
                                            <TableCell align="center">Commitment Date</TableCell>
                                            <TableCell align="center">Nphies Fee</TableCell>
                                            <TableCell align="center">Early Payment Fee</TableCell>
                                            <TableCell align="center">Benefit</TableCell>
                                            <TableCell align="center">Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{detailRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            {ele.noticestatus}
                        </TableCell>
                        {ele.noticeerror ? (<>
                            <TableCell align="center" style={{ fontSize: "small" }}>
                                <IconButton
                                    onClick={() =>
                                        this.setState({
                                            errorModal: true,
                                            elementNoticeError: ele.noticeerror
                                        })
                                    }
                                >
                                    <VisibilityIcon />
                                </IconButton>
                            </TableCell>

                        </>) : (<>
                            <TableCell align="center" style={{ fontSize: "small" }}>
                            </TableCell>
                        </>)}
                        <TableCell align="center" style={{ fontSize: "small" }}>
                            <IconButton
                                onClick={() =>
                                    this.setState({
                                        noticeModal: true,
                                        paymentReconciliationIdentifier: ele.paymentreconciliationidentifier,
                                        paymentDate: ele.paymentdate,
                                        paymentAmount: ele.paymentamount,
                                        paymentID: ele.id
                                    })
                                }
                            >
                                <PaidIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                )
            });
        }
        let errorsRow = []
        if (noticeErrors && noticeErrors.length > 0) {
            errorsRow = noticeErrors.map((element, index) => {
                return (
                    <TableRow key={index}>
                        <TableCell
                            align="center"
                            style={{ fontSize: "small" }}
                        >
                            {element.message}
                        </TableCell>
                        <TableCell
                            align="center"
                            style={{ fontSize: "small" }}
                        >
                            {element.expression}
                        </TableCell>
                    </TableRow>
                );
            });
        }

        return (
            <>
                <Box height={60} />
                <div style={{
                    textAlign: "left",
                    boxShadow: "1px solid grey",
                    boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                    borderRadius: "10px",
                    padding: "20px",
                    width: "95%",
                    overflowY: "auto"
                }}>
                    <div style={{ textAlign: "left", width: "250px" }}>

                        <Button variant="contained" style={{
                            backgroundColor: "rgb(97 110 120",
                            width: "100%",
                            transition: "background-color 0.4s, color 0.4s"
                        }}
                            onClick={(e) => this.handlePollRec(e)}
                        >
                            {this.state.pollLoading
                                ? "Loading..."
                                : "Polling Reconciliation"}

                        </Button>

                    </div>
                    <div style={{ width: "100%", overflow: "auto" }}>
                        {this.state.paymentLoading ? (
                            <CircularProgress />
                        ) : this.state.error ? (
                            <h6 style={{ textAlign: "center", fontSize: "20px" }}>{this.state.error}</h6>
                        ) :
                            (
                                <>
                                    {allPayments && allPayments.length > 0 ? (
                                        <div style={{ width: "55%", overflowX: "auto" }}>
                                            <TableContainer
                                                component={Paper}
                                                style={{ marginTop: "20px", overflowX: "auto" }}
                                            >
                                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                    <TableHead style={{ backgroundColor: "#fafafa" }}>
                                                        <TableRow style={{ textAlign: "center" }}>
                                                            <TableCell align="center">ID</TableCell>
                                                            <TableCell align="center">Payment Reconciliation Identifier</TableCell>
                                                            <TableCell align="center">Disposition</TableCell>
                                                            <TableCell align="center">Payment Date</TableCell>
                                                            <TableCell align="center">Payement Period</TableCell>
                                                            <TableCell align="center">Payment Amount</TableCell>
                                                            <TableCell align="center">Issuer Name</TableCell>
                                                            <TableCell align="center">Issuer ID</TableCell>
                                                            <TableCell align="center">Details</TableCell>
                                                            <TableCell align="center">Notice Status</TableCell>
                                                            {this.state.noticeErrorExist ? (<>
                                                                <TableCell align="center">Notice Error</TableCell>

                                                            </>) : null}
                                                            <TableCell align="center">Payment Notice</TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>{paymentRows}</TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    ) : (
                                        <h6 style={{ textAlign: "center", color: "red", fontSize: "15px" }}>There is No Payment Reconciliation</h6>
                                    )}
                                </>
                            )
                        }

                    </div>
                    {this.state.noticeModal ? (
                        <>
                            <Modal
                                open={this.state.noticeModal}
                                onClose={this.handleCloseNoticeModal}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            // style={{ overflowY: "scroll" }}
                            >
                                <Box
                                    sx={styleModal}
                                    style={{
                                        width: this.state.successNotice ? "50%" : "30%",
                                        height: this.state.successNotice ? "460px" : "200px",
                                    }}
                                >
                                    <Row>
                                        <Col>
                                            <FormControl style={{ width: "100%" }}>
                                                <InputLabel id="type" style={{ fontSize: "small" }}>
                                                    Payment Status
                                                </InputLabel>
                                                <Select
                                                    required
                                                    labelId="type"
                                                    name="paymentStatus"
                                                    label="Payment Status"
                                                    onChange={this.HandleInputTextChange}
                                                    style={{ height: "45px" }}
                                                    value={this.state.paymentStatus ? this.state.paymentStatus : ""}
                                                >
                                                    <MenuItem
                                                        value="paid"
                                                        style={{ fontSize: "small" }}
                                                    >
                                                        Paid
                                                    </MenuItem>
                                                    <MenuItem value="cleared" style={{ fontSize: "small" }}>
                                                        Cleared
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>

                                        </Col>

                                    </Row>
                                    <Row>
                                        <div style={{ width: "100%", marginTop: "20px", textAlign: "center" }}>
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: "rgb(97 110 120",
                                                    marginRight: "10px",
                                                }}
                                                onClick={(e) => this.handleSubmitPaymentNotice(e)}
                                            >
                                                {this.state.noticeLoading
                                                    ? "Loading..."
                                                    : "Submit"}
                                            </Button>
                                        </div>
                                    </Row>
                                    {(errorsRow &&
                                        errorsRow.length > 0) ? (
                                        <Row>

                                            <Typography
                                                id="modal-modal-title"
                                                variant="h6"
                                                component="h2"
                                                style={{ textAlign: "center", marginTop: "10px" }}
                                            >
                                                Errors
                                            </Typography>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    margin: "auto",
                                                    height: "300px"
                                                }}
                                            >
                                                <TableContainer
                                                    component={Paper}
                                                    style={{
                                                        margin: "auto",
                                                        width: "100%",
                                                        overflowY: "scroll"
                                                    }}
                                                >
                                                    <Table aria-label="simple table">
                                                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                                                            <TableRow style={{ textAlign: "center" }}>
                                                                <TableCell align="center">
                                                                    Error Message
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    Error Expression
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>{errorsRow}</TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        </Row>
                                    ) : this.state.acknowledgmentStatus === "ok" ? (<>
                                        <div
                                            style={{
                                                width: "100%",
                                                margin: "auto",
                                                paddingBottom: "20px",
                                            }}
                                        >
                                            <TableContainer
                                                component={Paper}
                                                style={{
                                                    margin: "auto",
                                                    width: "100%",
                                                    overflowY: "scroll"
                                                }}
                                            >
                                                <Table aria-label="simple table">
                                                    <TableHead style={{ backgroundColor: "#fafafa" }}>
                                                        <TableRow style={{ textAlign: "center" }}>
                                                            <TableCell align="center">
                                                                Acknowledgment Status
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                Bundle ID
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell align="center">
                                                                {this.state.acknowledgmentStatus}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {this.state.BundleID}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </>) : null}
                                </Box>
                            </Modal>
                        </>
                    ) : null}
                    {this.state.errorModal ? (
                        <>
                            <Modal
                                open={this.state.errorModal}
                                onClose={this.handleCloseErrorModal}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            // style={{ overflowY: "scroll" }}
                            >
                                <Box
                                    sx={styleModal}
                                    style={{
                                        width: "50%",
                                        height: "380"
                                    }}
                                >
                                    <Row>
                                        {this.state.elementNoticeError && this.state.elementNoticeError.length > 0 ? (
                                            <>
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        margin: "auto",
                                                        height: "300px"
                                                    }}
                                                >
                                                    <TableContainer
                                                        component={Paper}
                                                        style={{
                                                            margin: "auto",
                                                            width: "100%",
                                                            overflowY: "auto"
                                                        }}
                                                    >
                                                        <Table aria-label="simple table">
                                                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                                                                <TableRow style={{ textAlign: "center" }}>
                                                                    <TableCell align="center">
                                                                        Error Message
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        Error Expression
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.elementNoticeError.map((element, index) => {
                                                                    return (
                                                                        <TableRow key={index}>
                                                                            <TableCell
                                                                                align="center"
                                                                                style={{ fontSize: "small" }}
                                                                            >
                                                                                {element.message}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                align="center"
                                                                                style={{ fontSize: "small" }}
                                                                            >
                                                                                {element.expression}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );

                                                                })
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                            </>
                                        ) : null}

                                    </Row>

                                </Box>
                            </Modal>
                        </>
                    ) : null}

                </div>
            </>
        );
    }
}

export default PaymentReconsiliation;